module.exports = __webpack_public_path__ + "img/B-5.06373686.png";